import { ref, computed } from "vue";
import { AuthUserDTO, AuthUserModel } from "@/entities/AuthUser";
import { wapiClient } from "@/services/wapi";

const authUser = ref<AuthUserModel | null>(null);

const {
  isFetching: isFetchingAuthUser,
  data: authUserData,
  execute: executeFetchAuthUser,
} = wapiClient("/wapi/auth", {
  immediate: false,
}).json();

const {
  isFetching: isFetchingPressMedias,
  data: pressMediasData,
  execute: executeFetchPressData,
} = wapiClient("/wapi/auth/press-medias", {
  immediate: false,
}).json();

const { isFetching: isFetchingLogout, execute: executeFetchLogout } =
  wapiClient("/logout", {
    immediate: false,
  }).post();

function useAutUser() {
  async function fetchAuthUser() {
    await executeFetchAuthUser();
    if (authUserData?.value?.data) {
      authUser.value = new AuthUserModel(
        authUserData.value.data as AuthUserDTO
      );
      await executeFetchPressData();
      const mediasIds = pressMediasData.value.data;
      if (mediasIds) {
        authUser.value.setPressMediasIds(mediasIds);
      }
    }
  }

  async function logout() {
    authUser.value = null;
    await executeFetchLogout();
  }
  return {
    fetchAuthUser,
    authUser,
    isFetchingAuthUser: computed(
      () => isFetchingAuthUser.value || isFetchingPressMedias.value
    ),
    logout,
  };
}

export default useAutUser;
